const RUB = " ₽";

export function fmtRub(value: number): string {
  if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1).replace(".0", "")} млн${RUB}`;
  if (value >= 1000) return `${Math.round(value / 1000)} тыс${RUB}`;
  return `${value}${RUB}`;
}

export function fmtRubFull(value: number): string {
  return `${value.toLocaleString("ru-RU")}${RUB}`;
}

export function fmtNum(value: number): string {
  if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1).replace(".0", "")} млн`;
  if (value >= 1000) return `${(value / 1000).toFixed(0)} тыс`;
  return value.toString();
}

export function fmtNumFull(value: number): string {
  return value.toLocaleString("ru-RU");
}

export function fmtCpv(value: number): string {
  return `${value.toFixed(2).replace(".", ",")}${RUB}`;
}

export function fmtPct(value: number, digits = 1): string {
  return `${value.toFixed(digits).replace(".", ",")}%`;
}

const MONTHS_SHORT = ["янв","фев","мар","апр","май","июн","июл","авг","сен","окт","ноя","дек"];

export function fmtDate(iso: string): string {
  if (iso.includes(" — ")) {
    return iso.split(" — ").map(fmtDate).join(" — ");
  }
  const [, m, d] = iso.split("-").map(Number);
  if (!d || !m) return iso;
  return `${d} ${MONTHS_SHORT[m - 1] ?? ""}`;
}
